import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=bffa9648&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=bffa9648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa9648",
  null
  
)

export default component.exports